var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0938 4.5625C11.4688 3.8125 12.5312 3.84375 12.875 4.5625L14.9375 8.71875L19.5 9.375C20.3125 9.5 20.625 10.5 20.0312 11.0938L16.75 14.3125L17.5312 18.8438C17.6562 19.6562 16.7812 20.2812 16.0625 19.9062L12 17.75L7.90625 19.9062C7.1875 20.2812 6.3125 19.6562 6.4375 18.8438L7.21875 14.3125L3.9375 11.0938C3.34375 10.5 3.65625 9.5 4.46875 9.375L9.0625 8.71875L11.0938 4.5625Z",
    fill: "#FFC107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.5e3def5c.svg";
export { ForwardRef as ReactComponent };